<template>
  <div class="order">
    <div class="order_title">
      {{ $t("router.income") }}
      <!-- <img class="order_title_img" src="@/img/init.png" alt="" /> -->
    </div>
    <!-- 这个是 -->
    <div class="condition_box">
      <div class="condition">
        <div class="seek_input_box">
          <div class="seek_text">
            {{
              roleName && roleName.includes("GAME_DEVELOPER")
                ? $t("operational_data.game")
                : $t("operational_data.app")
            }}
          </div>
          <el-select
            :disabled="gameApp.length > 0 ? false : true"
            :no-data-text="$t('operational_data.no_result')"
            class="order_win"
            :placeholder="$t('operational_data.select')"
            v-model="appNamestate"
          >
            <el-option
              v-for="(item, index) in gameApp"
              :key="index"
              :label="item.appName"
              :value="index"
            ></el-option>
          </el-select>
        </div>
        <div class="time">
          <div class="time_text">{{ $t("operational_data.selecttime") }}</div>
          <div class="time_data">
            <a-range-picker
              :format="dataFormat"
              @change="onChange"
              :locale="locale"
              :disabled-date="disabledDate"
              @calendarChange="calendarPriceRangeChange"
              v-model="defaultDate"
              style="width: 320px; height: 40px"
            >
              <a-icon slot="suffixIcon" type="calendar" />
            </a-range-picker>
          </div>
        </div>
        <div style="margin-left: 20px">
          <el-radio-group v-model="radio1" @change="onRadioChange">
            <el-radio-button label="oneMonths">{{
              $t("operational_data.income.oneMonths")
            }}</el-radio-button>
            <el-radio-button label="threeMonths">{{
              $t("operational_data.income.threeMonths")
            }}</el-radio-button>
            <el-radio-button label="sixMonths">{{
              $t("operational_data.income.sixMonths")
            }}</el-radio-button>
          </el-radio-group>
        </div>
      </div>

      <div class="condition_btn CU" @click="getDownload">
        {{ $t("operational_data.data") }}
      </div>
      <div class="order_btn CU" @click="send">
        {{ $t("operational_data.send") }}
      </div>
    </div>
    <div class="data_title">
      {{ $t("operational_data.overview.dataOverview") }}
    </div>
    <div class="date_box">
      <div class="date">
        <div class="date_sum">${{ revenue.toFixed(2) }}</div>
        <div class="date_text">
          {{ $t("operational_data.income.incomeCount") }}
        </div>
      </div>
      <div class="date">
        <div class="date_sum">
          ${{ estimatedRevenue.toFixed(2) }}
          <el-tooltip class="item" effect="dark" placement="right-start">
            <div slot="content" class="tip">
              {{ $t("operational_data.income.tip") }}<br />
              {{ $t("operational_data.income.tipFirst") }}<br />
              {{ $t("operational_data.income.tipSecond") }}<br />
              {{ $t("operational_data.income.tipThird") }}
            </div>
            <img class="order_title_img" src="@/img/init.png" alt="" />
          </el-tooltip>
        </div>
        <div class="date_text">
          {{ $t("operational_data.income.estimatedRevenueCount") }}
        </div>
      </div>
    </div>

    <div class="gamelist_table">
      <a-config-provider>
        <template #renderEmpty style="">
          <div style="text-align: center; margin-top: 224px">
            <img src="@/img/kong.png" alt="" />
            <p>{{ $t("operational_data.no_result") }}</p>
          </div>
        </template>

        <template v-if="datalist == '' && tableloading" style="">
          <div style="text-align: center; margin-top: 224px">
            <loading></loading>
          </div>
        </template>

        <a-table
          v-if="datalist !== ''"
          @change="handleTableChange"
          :pagination="pagination"
          :scroll="{ x: true }"
          :columns="columns"
          :data-source="datalist"
          :rowKey="
            (record, index) => {
              return index;
            }
          "
        >
          <template slot="id" slot-scope="text, record, index">
            {{ 10000 - -index }}
          </template>
          <template slot="appName" slot-scope="text, record, index">
            {{ text }}
          </template>

          <template slot="checkState" slot-scope="text, record, index">
            {{ text }}
          </template>

          <template slot="version" slot-scope="text, record, index">
            {{ text }}
          </template>
          <template slot="lastModified" slot-scope="text, record, index">
            {{ text }}
          </template>
        </a-table>
      </a-config-provider>
    </div>

    <div class="" id="add" style="display: none">
      <el-table :data="tableAllData" highlight-current-row style="width: 100%">
        <template v-for="(item, index) in exportExcelArry">
          <el-table-column
            :prop="item.prop"
            :label="item.label"
          ></el-table-column>
        </template>
      </el-table>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import moment from "moment";
import "moment/locale/zh-cn";
import EN from "ant-design-vue/es/date-picker/locale/en_US";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import exportExcelCommon from "@/components/ExportExcelCommon.vue";
import loading from "@/components/loading/loading.vue";
import FileSaver from "file-saver";
import XLSX from "xlsx";
import { API_BASE_HOST } from "../../config/config";
import sumAnimation from "@/components/Operational_data/views/sumAnimation";

function isValidDate(date) {
  return date instanceof Date && !isNaN(date.getTime());
}
export default {
  components: {
    loading,
    sumAnimation,
  },
  data() {
    return {
      radio1: "",
      tableloading: false,
      roleName: localStorage.getItem("roleName"),
      dataFormat: "YYYY-MM-DD",
      // 开始时间
      endTime: moment().endOf("month").format("YYYY-MM-DD"),
      startTime: moment().startOf("month").format("YYYY-MM-DD"),
      // maxEndDate: null,
      offsetDays: 86400000 * 183, //最多选择7天

      // 结束时间
      // 订单号码
      orderId: "",
      // 用户的ID
      userId: "",
      // 订单的状态
      state: 0,
      offset: 0,
      count: 20,
      revenue: 0,
      estimatedRevenue: 0,
      selectPriceDate: "",
      defaultDate: (() => {
        const endTime = moment().endOf("month").format("YYYY-MM-DD");
        const startDate = moment().startOf("month").format("YYYY-MM-DD");
        return [startDate, endTime];
      })(),

      pagination: {
        defaultCurrent: 1,
        total: 0,
        pageSize: 20, //每页中显示20条数据
      },
      datalist: [],
      locale: EN,
      orderstatus: this.$t("operational_data.orderstatus"),
      columns: [
        {
          title: this.$t("operational_data.income.day"),
          dataIndex: "day",
          key: "day",
          scopedSlots: { customRender: "createTime" },
          customRender: (text, record) => {
            return moment(text).format("YYYY-MM-DD");
          },
        },
        {
          title:
            this.roleName && this.roleName.includes("GAME_DEVELOPER")
              ? this.$t("operational_data.game")
              : this.$t("operational_data.app"),
          dataIndex: "appName",
          key: "appName",
          scopedSlots: { customRender: "appName" },
          customRender: (text, record) => {
            if (this.roleName && this.roleName.includes("GAME_DEVELOPER")) {
              var data = JSON.parse(text);
              if (!data) {
                return "";
              }
              var newtext = data.find(
                (item) => item.lang.toLowerCase() == this.$i18n.locale
              );
              if (!newtext) {
                return JSON.parse(text)[0].values;
              }
              return newtext.values;
            }
            return text;
          },
        },
        {
          title: this.$t("operational_data.income.income"),
          dataIndex: "income",
          key: "income",
          scopedSlots: { customRender: "income" },
          customRender: (text, record) => {
            let data = text.toFixed(2);
            if (data == 0) {
              return "$" + 0.01;
            }
            return "$" + data;
          },
        },
        {
          title: this.$t("operational_data.income.estimatedRevenue"),
          dataIndex: "estimatedRevenue",
          key: "estimatedRevenue",
          scopedSlots: { customRender: "estimatedRevenue" },
          customRender: (text, record) => {
            var data = "$" + text.toFixed(2);
            return data;
          },
        },
      ],

      // APPid列表
      gameApp: [],
      appNamestate: "",
    };
  },
  created() {
    if (this.$i18n.locale == "zh") {
      moment.locale("zh-cn");
      this.locale = locale;
    } else {
      moment.locale("en_US");
      this.locale = EN;
    }
  },
  mounted() {
    if (this.$i18n.locale == "zh") {
      moment.locale("zh-cn");
      this.locale = locale;
    } else {
      moment.locale("en_US");
      this.locale = EN;
    }
    var self = this;
    if (localStorage.getItem("roleName").includes("GAME_DEVELOPER")) {
      this.getGameOnlineList({
        $axios: this.$axios,
      }).then((res) => {
        if (res.code == 200) {
          let data = res.data;
          if (data) {
            for (var i = 0; i < data.length; i++) {
              if (data[i].name.indexOf("[") != -1) {
                data[i].name = JSON.parse(data[i].name);
                var newtext = data[i].name.find(
                  (item) => item.lang.toLowerCase() == this.$i18n.locale
                );
                if (!newtext) {
                  newtext = data[i].name[0];
                }
                data[i].appName = newtext.values;
              }
            }
            let newDate = [
              {
                appName: "All",
              },
              ...data,
            ];
            self.gameApp = newDate;
            self.appNamestate = 0;
          }

          this.send();
        }
      });
    } else {
      this.AppList({
        $axios: this.$axios,
      }).then((res) => {
        if (res.code == 200) {
          let data = res.data;
          if (data) {
            for (var i = 0; i < data.length; i++) {
              if (data[i].appName.indexOf("[") != -1) {
                data[i].appName = JSON.parse(data[i].appName);
                var newtext = data[i].appName.find(
                  (item) => item.lang.toLowerCase() == this.$i18n.locale
                );
                if (!newtext) {
                  newtext = data[i].appName[0];
                }
                data[i].appName = newtext.values;
              }
            }
            let newDate = [
              {
                appName: "All",
              },
              ...data,
            ];
            self.gameApp = newDate;
            console.log("self.gameApp", newDate);
            self.appNamestate = 0;
          }

          this.send();
        }
      });
    }
  },
  methods: {
    ...mapActions("game", [
      "AppList",
      "getGameOnlineList",
      "getIncomeList",
      "getIncomeCount",
    ]),

    handleTableChange(pagination, filters, sorter) {
      this.offset = pagination.current;
      this.appId = this.appNamestate;
      this.getlist();
      this.getCount();
    },

    // 点击查询
    send() {
      this.datalist = [];
      this.offset = 1;
      this.appId = this.appNamestate;
      this.getlist();
      this.getCount();
    },

    // 获取数据
    async getlist() {
      const res = await this.getIncomeList({
        $axios: this.$axios,
        appId: this.gameApp[this.appNamestate].appId,
        current: this.offset,
        pageSize: 20,
        startDay: this.startTime,
        endDay: this.endTime,
      });
      if (res.code === 200) {
        this.datalist = res.data;
        this.pagination.total = res.total;
        this.tableloading = false;
      }
    },
    async getCount() {
      const res = await this.getIncomeCount({
        $axios: this.$axios,
        appId: this.gameApp[this.appNamestate].appId,
        current: this.offset,
        pageSize: 20,
        startDay: this.startTime,
        endDay: this.endTime,
      });
      if (res.code === 200) {
        this.revenue = res.data.revenue || 0;
        this.estimatedRevenue = res.data.estimatedRevenue || 0;
      }
    },

    async getDownload() {
      let url =
        API_BASE_HOST +
        "/tgaAd/portal/ad/income/download/excel?startDay=" +
        this.startTime +
        "&endDay=" +
        this.endTime;

      if (this.gameApp[this.appNamestate].appId) {
        url = url + "&appId=" + this.gameApp[this.appNamestate].appId;
      }
      this.downloadFile(url, "data", "xls");
    },
    //下载文件
    async downloadFile(url, fileName, fileType) {
      const baseUrl = url;
      var xhr = new XMLHttpRequest();
      xhr.open("get", baseUrl, true);
      xhr.responseType = "blob";
      xhr.setRequestHeader(
        "token",
        localStorage.getItem("mp_accessToken") || ""
      );
      xhr.onload = function () {
        if (this.status == 200) {
          const blob = new Blob([this.response], { type: fileType });
          var a = document.createElement("a");
          var url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = fileName + "." + fileType; // 文件名
          a.click();
          window.URL.revokeObjectURL(url);
        }
      };
      xhr.send();
    },

    moment,
    // 监听日期
    onChange(dates, dateStrings) {
      this.radio1 = "";
      this.selectPriceDate = "";
      this.startTime = dateStrings[0];
      this.endTime = dateStrings[1];
    },
    onRadioChange(e) {
      if (e === "oneMonths") {
        this.startTime = moment()
          .subtract(1, "months")
          .startOf("month")
          .format(this.dataFormat);
        this.endTime = moment()
          .subtract(1, "months")
          .endOf("month")
          .format(this.dataFormat);
      } else if (e === "threeMonths") {
        this.startTime = moment()
          .subtract(3, "months")
          .startOf("month")
          .format(this.dataFormat);
        this.endTime = moment()
          .subtract(1, "months")
          .endOf("month")
          .format(this.dataFormat);
      } else if (e === "sixMonths") {
        this.startTime = moment()
          .subtract(6, "months")
          .startOf("month")
          .format(this.dataFormat);
        this.endTime = moment()
          .subtract(1, "months")
          .endOf("month")
          .format(this.dataFormat);
      }
      this.defaultDate = [this.startTime, this.endTime];
    },
    NewData(data) {
      var d = new Date(data);
      var year = d.getFullYear(); //年
      var month = d.getMonth() + 1; //月
      var day = d.getDate(); //日
      var hh = d.getHours(); //时
      var mm = d.getMinutes(); //分
      var ss = d.getSeconds(); //秒
      var clock = year + "-";
      if (month < 10) clock += "0";
      clock += month + "-";
      if (day < 10) clock += "0";
      clock += day + " ";
      if (hh < 10) clock += "0";
      clock += hh + ":";
      if (mm < 10) clock += "0";
      clock += mm + ":";
      if (ss < 10) clock += "0";
      clock += ss;
      return clock;
    },
    //选择开始时间/结束时间
    calendarPriceRangeChange(date) {
      this.selectPriceDate = date[0];
    },
    disabledDate(current) {
      if (this.selectPriceDate) {
        let selectV = moment(this.selectPriceDate, "YYYY-MM-DD").valueOf();
        return (
          current > moment(new Date(this.maxEndDate), "YYYY-MM-DD") ||
          current > moment(new Date(selectV + this.offsetDays), "YYYY-MM-DD") ||
          current < moment(new Date(selectV - this.offsetDays), "YYYY-MM-DD")
        );
      } else {
        return current > moment(new Date(this.maxEndDate), "YYYY-MM-DD");
      }
    },
  },
};
</script>

<style scoped="scoped">
.order {
  width: 100%;
  min-height: 880px;
  /* height: 880px; */
  padding-top: 32px;
  padding-bottom: 40px;
}

.order_title {
  padding-left: 42px;
  color: #282828;
  font-size: 20px;
}

.order_title_img {
  width: 16px;
  height: 16px;
  margin-left: 19px;
}

.condition_box {
  margin-top: 33px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  background-color: #f5f7fa;
  border-bottom: solid 1px #eeeeee;
  margin-bottom: 25px;
}

.condition {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.condition_btn {
  width: 100px;
  height: 40px;
  background-color: #ffffff;
  border-radius: 4px;
  border: solid 1px #e6e6e6;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #666666;
}

.seek_input_box {
  margin-right: 20px;
  display: flex;
  align-items: center;
}

.seek_text {
  margin-right: 20px;
}

.seek_input {
  width: 241px;
  height: 34px;
}

.condition2 {
  margin-top: 25px;
  padding-left: 63px;
  display: flex;
}

.time {
  display: flex;
  align-items: center;
}

.time_text {
  color: #666666;
  font-size: 14px;
  margin-right: 24px;
}

.order_win {
  width: 176px;
  height: 40px;
}

.orderstatus {
  margin-left: 70px;
  display: flex;
  align-items: center;
}

.orderstatus_text {
  color: #666666;
  font-size: 14px;
  margin-right: 24px;
}

.data_title {
  padding-left: 40px;
  font-size: 18px;
  font-weight: bold;
  color: #282828;
  margin-bottom: 20px;
}

.order_btn {
  width: 90px;
  height: 40px;
  background-color: #5b99fa;
  border-radius: 4px;
  font-size: 14px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}

.gamelist_table {
  margin: 25px auto 0;
  width: 1265px;
}

.incomeCount {
  padding-left: 20px;
}

.date_box {
  padding-left: 40px;
  border-top: 1px solid #f3f3f3;
  /* border-bottom:  1px solid #f3f3f3; */
  padding-top: 30px;
  padding-bottom: 30px;
  display: flex;
}

.date {
  margin-right: 50px;
}

.date_sum {
  font-size: 28px;
  font-weight: bold;
  color: #282828;
}

.date_text {
  font-size: 14px;
  color: #aaaaaa;
  margin-top: 15px;
}

.tip {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Operational_data/income.vue